﻿export class CDN {
    public static Domain : string = `cinccdn.com`;
    public static Protocol : string = `https`;
    public static StaticSubDomain : string = `s-static`;
    public static StaticUrl : string = `${CDN.Protocol}://${CDN.StaticSubDomain}.${CDN.Domain}`;
}